// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, boolean } from "@altostra/type-validations/lib/primitives";

export const isAppsEngagementReportsUpdateArchivedStateResult = objectOf({
  info: string,
  undo_identifier: number,
  undo_data: objectOf({
    app_group_id: string,
    mark_as_archived: boolean,
    report_ids: arrayOf(string),
  }),
});
